import { SalesArticleSummary } from '@app/api';

export class LoadSalesArticle {
  static readonly type = '[Sales-Article] LoadSalesArticle';

  constructor(public id: number) {}
}

export class AddViewedSalesArticle {
  static readonly type = '[Sales-Article] AddViewedSalesArticle';

  constructor(public salesArticleId: string) {}
}

export class SetViewedSalesArticles {
  static readonly type = '[Sales-Article] SetViewedSalesArticles';

  constructor(public salesArticles: SalesArticleSummary[]) {}
}

export class RefreshViewedSalesArticles {
  static readonly type = '[Sales-Article] RefreshViewedSalesArticles';

  constructor() {}
}
